import Button from "@/common/components/Button";
import ResumeItem from "@/common/components/ResumeItem";
import { ShowHeader } from "@/common/components/ShowHeader";
import Table from "@/common/components/Table";
import { UnitTextField } from "@/common/components/UnitTextField";
import { CardType } from "@/common/constants/cards.constant";
import { unitStrategy } from "@/common/constants/unitStrategies.contants";
import { formatCurrency } from "@/common/utils/formatters";
import { defaultColumns } from "@/features/consumption/constants/columns.constants";
import { ConsumptionValidationSchema } from "@/features/consumption/schemas/create.schema";
import { useFormContext } from "react-hook-form";

interface ConsumptionMobileResumeScreenProps {
  handleTabChange: (tab: number) => void;
  setModalPasswordIsOpen: (value: boolean) => void;
  createConsumptionIsPending?: boolean;
}

const ConsumptionMobileResumeScreen = ({
  handleTabChange,
  setModalPasswordIsOpen,
  createConsumptionIsPending,
}: ConsumptionMobileResumeScreenProps) => {
  const {
    watch,
    register,
    formState: { errors },
  } = useFormContext<ConsumptionValidationSchema>();

  const watchTotalAmount = watch('total_amount');

  const watchProducts = watch('line_items_attributes');
  const cardType = watch('card_type');
  const categoryBypassConsumptionUsageValidations = watch("category_bypass_consumption_usage_validations");

  return (
    <div className="flex flex-col items-stretch w-screen h-dvh absolute top-0 left-0">
      <ShowHeader
        onGoBack={() => handleTabChange(0)}
        title="Voltar"
        className="p-4 mb-0"
        titleClassName="text-base font-normal"
        goBackIconSize={24}
      />

      <div className="h-full overflow-auto py-4 flex flex-col gap-3">
        {cardType === CardType.Fleet && !categoryBypassConsumptionUsageValidations && (
          <div className="flex flex-col gap-2 px-4">
            <p className="text-lg font-bold">Confirmação de segurança</p>

            <UnitTextField
              decimals={0}
              unit={unitStrategy.kilometers}
              maxValue={99_999_999}
              label="Quilometragem atual do equipamento"
              errorMessage={errors?.current_equipment_usage?.message}
              {...register('current_equipment_usage')}
              inputMode="numeric"
            />
          </div>
        )}

        <div className="flex flex-col gap-2 h-full">
          <p className="text-lg font-bold px-4">Resumo da transação</p>

          <Table
            columns={defaultColumns}
            isLoadingData={false}
            page={1}
            rows={watchProducts}
            totalPages={1}
            totalCount={watchProducts.length}
            loadingRows={4}
            className="rounded-none"
            footerClassName="rounded-none"
            flatHeader
          />
        </div>
      </div>

      <div className="mt-auto bg-white-200 p-4">
        <div className="flex items-center justify-between">
          <div>
            <ResumeItem
              label="Valor total"
              value={formatCurrency(watchTotalAmount || 0)}
              valueClassName="-mt-1 font-bold"
            />
          </div>

          <Button
            name='submit'
            type="button"
            onClick={() => setModalPasswordIsOpen(true)}
            isLoading={createConsumptionIsPending}
          >
            Efetuar transação
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ConsumptionMobileResumeScreen;
